import Navbar from '../../components/feature/Navbar';
import Footer from '../home/components/Footer';

export default function About() {
  const team = [
    {
      name: 'Ahmed El Mansouri',
      role: 'Head Instructor & Founder',
      experience: '15 years',
      certifications: ['IKO Level 3', 'ISA Certified', 'Lifeguard'],
      image: 'https://public.readdy.ai/ai/img_res/bc1ccb81c9b6dd21a39cbe1adc0939a2.jpg',
      specialty: 'Surf & Kitesurf'
    },
    {
      name: 'Sofia Martinez',
      role: 'Kitesurf Instructor',
      experience: '8 years',
      certifications: ['IKO Level 2', 'First Aid'],
      image: 'https://readdy.ai/api/search-image?query=female-kitesurfing-instructor-portrait-smiling-confident-woman-on-beach-professional-athletic-simple-clean-background&width=600&height=600&seq=instructor-sofia-012&orientation=squarish',
      specialty: 'Kitesurf Specialist'
    },
    {
      name: 'Youssef Benali',
      role: 'Surf Instructor',
      experience: '10 years',
      certifications: ['ISA Level 2', 'Lifeguard'],
      image: 'https://readdy.ai/api/search-image?query=young-moroccan-surf-instructor-portrait-smiling-friendly-man-with-wetsuit-on-beach-simple-clean-background&width=600&height=600&seq=instructor-youssef-013&orientation=squarish',
      specialty: 'Beginner Specialist'
    },
    {
      name: 'Emma Johnson',
      role: 'Surf Instructor',
      experience: '6 years',
      certifications: ['ISA Level 1', 'First Aid'],
      image: 'https://readdy.ai/api/search-image?query=female-surf-instructor-portrait-smiling-confident-woman-with-surfboard-on-beach-professional-simple-clean-background&width=600&height=600&seq=instructor-emma-014&orientation=squarish',
      specialty: 'Kids & Teens'
    }
  ];

  const values = [
    {
      title: 'Safety First',
      description: 'Your safety is our absolute priority. We follow strict protocols and use the best equipment.',
      icon: 'ri-shield-check-line',
      color: 'teal'
    },
    {
      title: 'Expert Instruction',
      description: 'All our instructors are internationally certified and passionate about teaching.',
      icon: 'ri-medal-line',
      color: 'orange'
    },
    {
      title: 'Small Groups',
      description: 'We maintain low student-to-instructor ratios for personalized attention.',
      icon: 'ri-group-line',
      color: 'blue'
    },
    {
      title: 'Ocean Respect',
      description: 'We teach sustainable practices and respect for the ocean environment.',
      icon: 'ri-leaf-line',
      color: 'green'
    }
  ];

  const stats = [
    { number: '10+', label: 'Years Experience' },
    { number: '5000+', label: 'Happy Students' },
    { number: '15', label: 'Expert Instructors' },
    { number: '98%', label: 'Success Rate' }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-[60vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=surf-school-team-group-photo-on-essaouira-beach-with-surfboards-and-kites-happy-instructors-and-students-ocean-background-simple-clean-composition&width=1920&height=1080&seq=about-hero-015&orientation=landscape"
            alt="About Us"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>
        <div className="relative z-10 text-center px-6 max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            About Destination Essaouira
          </h1>
          <p className="text-xl text-white/95 max-w-2xl mx-auto">
            Essaouira's premier surf and kitesurf school since 2014
          </p>
        </div>
      </section>

      {/* Our Story Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                Our Story
              </h2>
              <div className="space-y-4 text-base text-gray-700 leading-relaxed">
                <p>
                  Founded in 2014 by Ahmed El Mansouri, a passionate surfer and Essaouira native, Destination Essaouira was born from a simple dream: to share the magic of surfing and kitesurfing with people from around the world.
                </p>
                <p>
                  What started as a small operation with just two instructors has grown into one of Morocco's most respected surf schools. We've taught thousands of students from over 50 countries, helping them discover the joy of riding waves in one of the world's most beautiful locations.
                </p>
                <p>
                  Our team combines local knowledge with international teaching standards. We know Essaouira's beaches, winds, and waves like no one else, and we're certified by the world's leading surf and kitesurf organizations.
                </p>
                <p>
                  Today, we're proud to be a community hub for water sports enthusiasts, offering not just lessons but a complete experience of Essaouira's unique surf culture.
                </p>
              </div>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-2xl h-[500px]">
              <img
                src="https://readdy.ai/api/search-image?query=essaouira-beach-panoramic-view-with-surfers-and-kites-in-water-beautiful-moroccan-coastline-vibrant-colors-simple-clean-composition&width=800&height=1000&seq=about-story-016&orientation=portrait"
                alt="Our Story"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-20 bg-gradient-to-r from-teal-500 to-teal-600">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-5xl md:text-6xl font-bold text-white mb-2">
                  {stat.number}
                </div>
                <div className="text-base text-white/90 font-medium">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Our Values
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              What makes us different and why students choose us
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all text-center">
                <div className={`w-16 h-16 flex items-center justify-center bg-${value.color}-100 rounded-full mx-auto mb-6`}>
                  <i className={`${value.icon} text-3xl text-${value.color}-600`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{value.title}</h3>
                <p className="text-sm text-gray-600">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Meet Our Team
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Experienced, certified, and passionate instructors
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {team.map((member, index) => (
              <div key={index} className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all">
                <div className="w-full h-80 bg-gray-100">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-1">{member.name}</h3>
                  <p className="text-sm text-teal-600 font-semibold mb-2">{member.role}</p>
                  <p className="text-xs text-gray-600 mb-4">{member.specialty}</p>
                  <div className="mb-4">
                    <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">
                      Experience: {member.experience}
                    </p>
                  </div>
                  <div>
                    <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">
                      Certifications:
                    </p>
                    <div className="flex flex-wrap gap-2">
                      {member.certifications.map((cert, idx) => (
                        <span key={idx} className="text-xs bg-gray-100 text-gray-700 px-3 py-1 rounded-full">
                          {cert}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Certifications Section */}
      <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Certifications & Partnerships
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Recognized by international surf and kitesurf organizations
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {[
              { name: 'IKO Certified', description: 'International Kiteboarding Organization', icon: 'ri-award-line' },
              { name: 'ISA Approved', description: 'International Surfing Association', icon: 'ri-medal-line' },
              { name: 'First Aid Certified', description: 'All instructors trained', icon: 'ri-heart-pulse-line' },
              { name: 'Insured', description: 'Full liability coverage', icon: 'ri-shield-check-line' }
            ].map((cert, index) => (
              <div key={index} className="text-center">
                <div className="w-20 h-20 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-4">
                  <i className={`${cert.icon} text-4xl text-teal-600`}></i>
                </div>
                <h3 className="text-base font-bold text-gray-900 mb-2">{cert.name}</h3>
                <p className="text-xs text-gray-600">{cert.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-orange-500 to-orange-600">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Join Our Community
          </h2>
          <p className="text-xl text-white/95 mb-8">
            Become part of the Destination Essaouira family and experience the best surf and kitesurf lessons in Morocco
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <a
              href="/contact"
              className="bg-white text-orange-600 px-8 py-4 rounded-full font-semibold text-base whitespace-nowrap hover:bg-gray-100 transition-all shadow-lg hover:shadow-xl cursor-pointer"
            >
              Book Your Lesson
            </a>
            <a
              href="https://wa.me/212600000000"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-500 text-white px-8 py-4 rounded-full font-semibold text-base whitespace-nowrap hover:bg-green-600 transition-all shadow-lg hover:shadow-xl cursor-pointer"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              Contact Us
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
